var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 0C3.58871 0 0 3.58876 0 7.99989C0 12.411 3.58871 15.9998 7.9998 15.9998C12.4109 15.9998 15.9996 12.411 15.9996 7.99989C15.9996 3.58876 12.4109 0 7.9998 0Z",
    fill: "#FFC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98448 12.4322C9.65765 12.4322 11.2611 11.5765 12.1792 10.1558L11.4528 9.68637C10.6098 10.991 9.06722 11.7191 7.52351 11.5409C6.32017 11.4021 5.20738 10.7088 4.54668 9.68637L3.82031 10.1558C4.61976 11.393 5.9671 12.2319 7.42438 12.4C7.61146 12.4216 7.79826 12.4322 7.98448 12.4322Z",
    fill: "#413E34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39831 8.12972C5.63561 8.12972 5.85042 8.03399 6.00669 7.87924C6.16501 7.72253 6.26318 7.50518 6.26318 7.26486C6.26318 6.78724 5.87593 6.39999 5.39831 6.39999C4.92069 6.39999 4.53345 6.78724 4.53345 7.26486C4.53345 7.37724 4.55556 7.48426 4.59458 7.5828C4.72139 7.90297 5.03307 8.12972 5.39831 8.12972Z",
    fill: "#413E34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5353 7.5828C11.5743 7.48432 11.5964 7.37724 11.5964 7.26486C11.5964 6.78724 11.2092 6.39999 10.7316 6.39999C10.2539 6.39999 9.8667 6.78724 9.8667 7.26486C9.8667 7.50518 9.96486 7.72253 10.1232 7.87929C10.2795 8.03399 10.4943 8.12972 10.7316 8.12972C11.0968 8.12972 11.4085 7.90297 11.5353 7.5828Z",
    fill: "#413E34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackP);
export default __webpack_public_path__ + "static/media/feedback-p.a600af6ecbe405568b6298b284b24ebf.svg";
export { ForwardRef as ReactComponent };